// extracted by mini-css-extract-plugin
export var topContainer = "styles-module__topContainer___U_f1n";
export var mobileContainer = "styles-module__mobileContainer___U2I5J";
export var content = "styles-module__content___Gp50l";
export var titleTop = "styles-module__titleTop___p4uHz";
export var titleBottom = "styles-module__titleBottom___ajEcG";
export var text = "styles-module__text___M13Q3";
export var badgeStarContainer = "styles-module__badgeStarContainer___nq_Po";
export var badgeImage = "styles-module__badgeImage___XonzI";
export var rating = "styles-module__rating___Rh52Z";
export var starsImage = "styles-module__starsImage___ISN4G";
export var bottomContainer = "styles-module__bottomContainer___Kx0ey";
export var carousel = "styles-module__carousel___y67He";
export var slideContainer = "styles-module__slideContainer___cct2a";
export var slideImage = "styles-module__slideImage___UQVDp";
export var dots = "styles-module__dots___VLQ0F";
export var dot = "styles-module__dot___M2Arf";
export var active = "styles-module__active___Q8NRe";
export var upArrow = "styles-module__upArrow___QP3i_";
export var downArrow = "styles-module__downArrow___CsB_W";
export var nav = "styles-module__nav___wkCvT";
export var title = "styles-module__title___btYZZ";
export var featureText = "styles-module__featureText___CK2qx";
export var signUpLink = "styles-module__signUpLink___QLPRI";
export var picture = "styles-module__picture___UK4zE";
export var navLink = "styles-module__navLink___r_IYp";
export var last = "styles-module__last___qqIpJ";
export var screen = "styles-module__screen___Q09u8";
export var screenImage = "styles-module__screenImage___EjF6a";
export var feature = "styles-module__feature___E2rNB";
export var featureContent = "styles-module__featureContent___xXBqD";
export var img = "styles-module__img___ga7Jf";